
import ClickOutside from "vue-click-outside";
import { mapGetters, mapState } from "vuex";

export default {
  directives: { ClickOutside },

  computed: {
    ...mapGetters("bedbuilder", ["showOptionsModalOpen"]),
    ...mapState("bedbuilder", ["showBedBuilderOptionsChange"]),
  },

  methods: {
    hideSubOptionsModal() {
      if (this.showBedBuilderOptionsChange) {
        return;
      }

      this.$store.dispatch("bedbuilder/closeSubOptionsModal");
    },
  },
};
